<template>
  <div>
    <TifDistrictsList/>
  </div>
</template>
<script>
import TifDistrictsList from '../../../components/tax/TifDistricts/TifDistrictsList.vue';

export default {
  name: 'TifDistricts',
  components: {
    TifDistrictsList,
  },
};
</script>
